import type { FaireProductEntity } from "../../entity_types/product";

export const p_xaqb4gnnad: FaireProductEntity = {
  token: "p_xaqb4gnnad",
  type: "product",
  name: "Be Still And Know Desktop Notepad",
  brandName: "Church Notes Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/4d705810004157b66e57c7a33395115add8bd778e99f7fcaabb462ab9ed16a2b.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/05df521e8868f834796088397970cd2e8dd7c3ef249c0a753f13306bd6da30b9.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
